import SocialLinks from "./SocialLinks";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/5 mt-24 py-10 px-6 md:px-10 text-zinc-500 text-sm"
        >
            <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row gap-6 md:items-center justify-between">
                <div className="font-display text-lg text-white">
                    rabitsch<span className="text-[var(--rb-primary)]">.</span>supporter
                </div>
                <SocialLinks />
                <div className="uppercase tracking-[0.22em] text-xs">
                    Eine kleine musikalische Reise · Wien
                </div>
            </div>
        </footer>
    );
}
